import _slicedToArray from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import providerApiService from "../../../../services/api/ProviderApiService";
import { isArray } from "lodash";
import { mapGetters } from "vuex";
export default {
  name: "ProviderZonesList",
  components: {},
  data: function data() {
    return {
      polygons: [],
      providerDeliveryFees: []
    };
  },
  computed: _objectSpread({
    propertyAAndPropertyB: function propertyAAndPropertyB() {
      return "".concat(JSON.stringify(this.polygons), "|").concat(JSON.stringify(this.providerDeliveryFees));
    }
  }, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  watch: {
    propertyAAndPropertyB: function propertyAAndPropertyB(newVal) {
      var _newVal$split = newVal.split("|"),
          _newVal$split2 = _slicedToArray(_newVal$split, 2),
          newPropertyA = _newVal$split2[0],
          newPropertyB = _newVal$split2[1];

      var polygons = JSON.parse(newPropertyA);
      var providerDeliveryFees = JSON.parse(newPropertyB);

      if (polygons && polygons.length > 0 && providerDeliveryFees && providerDeliveryFees.length > 0) {
        this.polygons = polygons.map(function (item) {
          var selected = item;
          providerDeliveryFees.forEach(function (element) {
            if (item.id === element.zone) {
              selected = _objectSpread(_objectSpread({}, item), {}, {
                feeId: element.id,
                fee: element.fee
              });
            }
          });
          return selected;
        });
      }
    }
  },
  methods: {
    getAllPolygons: function getAllPolygons() {
      var _this = this;

      providerApiService.getAllMapPolygons().then(function (result) {
        _this.polygons = result.data;

        _this.getProviderDeliveryFees();
      });
    },
    getProviderDeliveryFees: function getProviderDeliveryFees() {
      var _this2 = this;

      providerApiService.getProviderDeliveryFees(this.currentProvider.id).then(function (result) {
        if (isArray(result.data) && result.data.length > 0) {
          _this2.providerDeliveryFees = result.data;
        }
      });
    },
    selectZone: function selectZone(zone) {
      this.$emit("selectZone", zone);
    }
  },
  mounted: function mounted() {
    this.getAllPolygons();
  }
};